var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SettingsField = function (_a) {
    var label = _a.label, children = _a.children, _b = _a.labelWidth, labelWidth = _b === void 0 ? 5 : _b, _c = _a.valueWidth, valueWidth = _c === void 0 ? 7 : _c, tooltip = _a.tooltip, _d = _a.labelClassName, labelClassName = _d === void 0 ? '' : _d;
    return (_jsxs("div", __assign({ className: "form-group" }, { children: [_jsxs("label", __assign({ className: "control-label col-md-".concat(labelWidth).concat(labelClassName ? " ".concat(labelClassName) : '') }, { children: [label, tooltip && (_jsx("span", __assign({ className: "clickable", title: tooltip }, { children: _jsx("i", { className: "fa fa-question-circle-o" }) })))] })), _jsx("div", __assign({ className: "col-md-".concat(valueWidth) }, { children: children }))] })));
};
export default SettingsField;
